var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 10.9375H18.3594V7.42188C18.3594 3.33008 15.0293 0 10.9375 0C6.8457 0 3.51562 3.33008 3.51562 7.42188V10.9375H2.34375C1.0498 10.9375 0 11.9873 0 13.2812V22.6562C0 23.9502 1.0498 25 2.34375 25H19.5312C20.8252 25 21.875 23.9502 21.875 22.6562V13.2812C21.875 11.9873 20.8252 10.9375 19.5312 10.9375ZM14.4531 10.9375H7.42188V7.42188C7.42188 5.4834 8.99902 3.90625 10.9375 3.90625C12.876 3.90625 14.4531 5.4834 14.4531 7.42188V10.9375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.162a69c764acce64276a1ddf84b10da2.svg";
export { ForwardRef as ReactComponent };